import { render } from "./VendorTransactionsModal.vue?vue&type=template&id=0bbcb432"
import script from "./VendorTransactionsModal.vue?vue&type=script&lang=js"
export * from "./VendorTransactionsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__